webpackJsonp([72776394686286],{

/***/ 408:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _YellowButtonMD = __webpack_require__(40);
	
	var _YellowButtonMD2 = _interopRequireDefault(_YellowButtonMD);
	
	__webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var News = function News(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-3 News-Card', key: props.id, onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)(props.path);
	            } },
	        _react2.default.createElement(
	            'small',
	            { className: 'News-Date' },
	            props.date
	        ),
	        _react2.default.createElement(
	            'h2',
	            { className: 'News-Title' },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: props.path },
	                props.desc
	            )
	        ),
	        _react2.default.createElement(
	            'h3',
	            { className: 'News-Desc' },
	            props.title
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'by: ',
	            props.author
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'News-Content' },
	            props.children
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'News-Button' },
	            _react2.default.createElement(
	                _YellowButtonMD2.default,
	                { path: props.path },
	                'View Details \xBB'
	            )
	        )
	    );
	};
	
	exports.default = News;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _News = __webpack_require__(269);
	
	var _News2 = _interopRequireDefault(_News);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "container", style: { paddingBottom: '40px' } },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                data.allMarkdownRemark.edges.map(function (_ref2) {
	                    var node = _ref2.node;
	                    return _react2.default.createElement(
	                        _News2.default,
	                        {
	                            key: node.id,
	                            desc: node.frontmatter.desc,
	                            title: node.frontmatter.title,
	                            date: node.frontmatter.date,
	                            path: node.frontmatter.path,
	                            author: node.frontmatter.author
	                        },
	                        node.excerpt
	                    );
	                })
	            )
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-d7b5cf88edb69cb234bc.js